import { IExchangeRateItem } from "interfaces";
import { get } from "lodash";
import { CURRENCY_LIST } from "utills/constants";
import { formatNumber } from "utills/helpers";

interface ExchangeRateCardProps {
  data: IExchangeRateItem;
}

export const ExchangeRateCard = ({data }: ExchangeRateCardProps) => {
  return (
    <ul className="bg-white">
      {Object.keys(data?.rates ?? {}).map((key: string, index: number) => (
        <div key={index} className="flex flex-col gap-y-4 overflow-hidden shadow-md ring-1 ring-gray-900/5 [&:not(:last-child)]:mb-4 p-4 rounded-xl">
          <li className="relative flex items-center justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">
              No
            </p>
            <p className="flex-1 text-right text-sm leading-6">
              {index + 1}
            </p>
          </li>
          <li className="relative flex items-center justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">
              Currency name
            </p>
            <p className="flex-1 text-right text-sm leading-6">{CURRENCY_LIST.find(currency => currency.code === key)?.name ?? key}</p>
          </li>
          <li className="relative flex items-center justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">
              Alphabetic Code
            </p>
            <p className="flex-1 text-right text-sm leading-6">{key}</p>
          </li>
          <li className="relative flex items-center justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">
              Exchange rate
            </p>
            <p 
              className="text-right text-sm leading-6 shrink-0"
              data-tooltip-id="tooltip"
              data-tooltip-content={get(data.rates, key, 0).toString()}
            >
              {formatNumber(Math.round(get(data?.rates, key, 0)))}
            </p>
          </li>
        </div>
      ))}
    </ul>
  )
}